import Vue from 'vue';

Vue.component('profit-index', () =>
    import(/* webpackChunkName: 'profit-index' */ './profit-index.vue'),
);

Vue.component('profit-index-es', () =>
    import(/* webpackChunkName: 'profit-index-es' */ './es-report/profit-index-es.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/profit/index.js